export class ScriptDetail {
    isLoaded: boolean;
    name: string;
    source: string;
}
